<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Stats',
};
</script>

<style scoped>

</style>
